import locales from '../constants/locales';
import legalLinks from '../data/legalLinks';

const enPrefix = `/${locales.en.path}`;

export const localeOfPath = (pathname) => (
  pathname === enPrefix || pathname.startsWith(`${enPrefix}/`) ? 'en' : 'fr'
);

// Same page in another language: /en prefix added or removed, legal pages mapped by name
export const translatePath = (pathname, targetKey) => {
  const sourceKey = localeOfPath(pathname);
  let basePath = sourceKey === 'en' ? pathname.slice(enPrefix.length) || '/' : pathname;
  const fromLegal = legalLinks[sourceKey];
  const legalKey = Object.keys(fromLegal)
    .find((key) => fromLegal[key] === basePath || fromLegal[key] === `${basePath}/`);
  if (legalKey) basePath = legalLinks[targetKey][legalKey];
  return locales[targetKey].default ? basePath : `/${locales[targetKey].path}${basePath}`;
};
